
import rawSchemes from "~/data/schemes.json";

export default () => {
	return (
		<>
			<div class="col-span-full min-h-screen bg-gray-50 p-8">
				<div class="max-w-5xl mx-auto">
					{/*<!-- Page header -->*/}
					<h1 class="text-3xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h1>

					<h2 class="text-2xl font-semibold text-gray-800 mb-4">How and Why to Join</h2>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							Who is eligible to join?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600">
							<p>All construction professionals with suitable qualifications and experience. The following pre-qualify:</p>
							<ol class="list-decimal list-inside space-y-1 mt-2">
								<li>Architects registered with the ARB</li>
								<li>Chartered Members of CIAT</li>
								<li>Corporate Members and LCCs registered with CIBSE</li>
								<li>Existing Approved Certifiers of Design</li>
							</ol>
						</div>
					</details>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							Why should I join?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600">
							<p>As an Approved Certifier of Design, you will:</p>
							<ol class="list-decimal list-inside mt-2 space-y-1">
								<li>Retain control of the energy aspects of your projects</li>
								<li>Help design teams optimise energy strategies</li>
								<li>Provide clients with an enhanced service</li>
								<li>Minimise local authority verification time</li>
								<li>Benefit from a 10% discount on building warrant fees (if certifying all relevant elements)</li>
								<li>Stay updated with technical standards and access technical advice</li>
							</ol>
						</div>
					</details>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							Why are the Domestic and Non-domestic Schemes separate?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600">
							<p>
								The software differs between domestic and non-domestic calculations. By separating them, professionals don’t need to demonstrate competency in tools they rarely use.
							</p>
						</div>
					</details>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							Why is there a distinction between Non-domestic and “Advanced” Non-domestic Approved Certifiers?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600 space-y-2">
							<p>
								Both are registered as Approved Certifiers of Design. The distinction exists because complex non-domestic buildings (schools, hospitals, etc.) require deeper HVAC and systems expertise than simpler non-domestic projects.
							</p>
							<p>
								Guidance defines when a project is “Advanced.” It’s not only about scale or cost — complexity of services and systems is the key factor.
							</p>
						</div>
					</details>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							Can I certify Section 6 – Energy if there are no external fabric changes?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600">
							<p>
								Yes. Section 6 – Energy applies to all building warrant applications, even if works are internal. Certification still gives a 10% fee discount.
							</p>
						</div>
					</details>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							How do I join?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600">
							<p>Membership has four stages:</p>
							<ol class="list-decimal list-inside mt-2 space-y-1">
								<li>Initial application</li>
								<li>Online competency tests</li>
								<li>Practical calculation test / confirmation of prior competency</li>
								<li>Identity and Approved Body checks</li>
							</ol>
						</div>
					</details>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							What does an Approved Body do?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600">
							<p>
								Certificates can only be issued by an Approved Certifier working for an Approved Body (a company, practice, department, or sole practitioner). Each must appoint a Certification Coordinator to oversee compliance and countersign certificates.
							</p>
						</div>
					</details>

					<h2 class="text-2xl font-semibold text-gray-800 mt-10 mb-4">What are the Costs?</h2>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							What does it cost to register my interest?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600">
							<p>Nothing. Registering simply allows us to keep you updated.</p>
						</div>
					</details>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							What will it cost to apply to join the scheme?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600 space-y-2">
							<p>Joining fee:</p>
							<ul class="list-disc list-inside">
								<li>Domestic – £{rawSchemes.s6Domestic.joiningFee} + VAT</li>
								<li>Non-Domestic – £{rawSchemes.s6NonDomestic.joiningFee} + VAT</li>
								<li>Non-Domestic Advanced – £{rawSchemes.s6NonDomesticAdv.joiningFee} + VAT</li>
							</ul>
							<p>Annual subscription (first year at application):</p>
							<ul class="list-disc list-inside">
								<li>Domestic – £{rawSchemes.s6Domestic.renewalFee} + VAT</li>
								<li>Non-Domestic – £{rawSchemes.s6NonDomestic.renewalFee} + VAT</li>
								<li>Non-Domestic Advanced – £{rawSchemes.s6NonDomesticAdv.renewalFee} + VAT</li>
							</ul>
						</div>
					</details>


					<h2 class="text-2xl font-semibold text-gray-800 mt-10 mb-4">How the Schemes Work</h2>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							What details do you check?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600">
							<p>During registration, you must confirm details such as:</p>
							<ol class="list-decimal list-inside mt-2">
								<li>ARB registration number</li>
								<li>CIAT membership number</li>
								<li>CIBSE LCC number</li>
							</ol>
							<p>
								These will be checked before membership confirmation.
							</p>
						</div>
					</details>


					<h2 class="text-2xl font-semibold text-gray-800 mt-10 mb-4">Energy Performance Certificates (EPCs)</h2>

					<details class="bg-white shadow rounded-xl p-5 mb-4 group">
						<summary class="flex justify-between items-center cursor-pointer font-medium text-gray-800">
							How do EPCs work in this scheme?
							<span class="transition-transform group-open:rotate-180 text-2xl font-bold">⌄</span>
						</summary>
						<div class="mt-3 text-gray-600 space-y-2">
							<p>
								Approved Certifiers must be members of an Approved Organisation to lodge EPCs.
								Domestic: Quidos.
								Non-domestic: CIBSE Low Carbon Consultants.
							</p>
							<p>
								See the <a href="https://www.gov.scot/Topics/Built-Environment/Building/Building-standards/enerperfor/epcorgprg" class="text-blue-600 hover:underline">Scottish Government list of Approved Organisations</a>.
							</p>
						</div>
					</details>
				</div>
			</div>
		</>
	)
}
